import fetch from "unfetch";

export const fetchSchools = (city, state) => {
  return fetch(
    `${process.env.API_URL}/schools/find?` +
      new URLSearchParams({
        city: city,
        state: state,
      })
  );
};
